import React, { useState } from 'react'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import ChevronLeft from '../../../assets/svg/Feather/ChevronLeft'
import ChevronRight from '../../../assets/svg/Feather/ChevronRight'
import styles from './PhotoViewer.module.scss'
import Trash from '../../../assets/svg/Feather/Trash2'
import X from '../../../assets/svg/Feather/X'

const PhotoViewer = (props) => {
	const feature = props.feature

	const [photoIndex, setPhotoIndex] = useState(feature.photos.findIndex((photoItem) => photoItem.uuid === props.photo.uuid))

	const previousPhoto = () => {
		const newPhotoIndex = photoIndex === 0 ? feature.photos.length - 1 : photoIndex - 1
		setPhotoIndex(newPhotoIndex)
	}

	const nextPhoto = () => {
		const newPhotoIndex = photoIndex === feature.photos.length - 1 ? 0 : photoIndex + 1
		setPhotoIndex(newPhotoIndex)
	}

	const photo = feature.photos[photoIndex]

	const navigationDisabled = feature.photos.length < 2
	const reactStyles = {
		chevron: {
			color: !navigationDisabled ? '#fff' : '#8e8e92',
		}
	}

	return (
		<div className={styles.photoViewer}>
			<div className={styles.photoHeader}>
				<span className={styles.photoName}>{photo.title}</span>
				<div className={styles.photoViewerActions}>
					<button onClick={props.deletePhoto} className={styles.deletePhoto}>
						<Trash width={16} color='#fff' />
					</button>
					<button onClick={props.closePhotoViewer} className={styles.closePhotoViewer}>
						<X width={20} color='#fff' />
					</button>
				</div>
			</div>
			<span className={styles.photoDate}>{dayjs.unix(+photo.createdAt).format('MMM DD, YYYY h:mm A')}</span>
			<div className={styles.photoContainer}>
				<img src={photo.fileData != null ? photo.fileData : photo.pathWeb} className={styles.originalPhoto} />
				<div className={styles.photoCountContainer}>
					<button onClick={previousPhoto} disabled={navigationDisabled} className={styles.chevronLeft}>
						<ChevronLeft width={20} color={reactStyles.chevron.color} />
					</button>
					<div className={styles.photoCounter}>
						Photo {photoIndex + 1} of {feature.photos.length}
					</div>
					<button onClick={nextPhoto} disabled={navigationDisabled} className={styles.chevronRight}>
						<ChevronRight width={20} color={reactStyles.chevron.color} />
					</button>
				</div>
			</div>
		</div>
	)
}

PhotoViewer.propTypes = {
	feature: PropTypes.object,
	photo: PropTypes.object,
	closePhotoViewer: PropTypes.func,
	deletePhoto: PropTypes.func,
}

export default PhotoViewer
